/**
 * The "via" line (ruling Z6d): which prequalification site created a buyer.
 *
 * The SERVER decides whether a buyer has one — only when its source is the
 * prequalification form AND the completion that CREATED it (the funnel's create
 * or a staff send, never a link, never `SourceDetail`) carried a partner brand.
 * So this formats what it is handed and never infers a site of its own: a null
 * site means "no line", which is the right answer for the native site and for a
 * buyer that only ever had completions linked to it.
 */
export function createdViaLabel(
  b: { createdViaSite?: string | null; createdViaSiteOwner?: string | null },
  options: { withOwner: boolean },
): string | null {
  const site = b.createdViaSite?.trim();
  if (!site) return null;
  const owner = b.createdViaSiteOwner?.trim();
  return options.withOwner && owner ? `via ${site} (${owner})` : `via ${site}`;
}
